import React, { Component } from "react";
import PropTypes from "prop-types";
import $ from "jquery";

class EditableField extends Component {
  constructor(props) {
    super(props);

    // Set Initial State
    this.state = {
      isEdit: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    $(this.mRef).find(".action").html(this.getActionIcon());
    $(this.mRef).find(".action").on("click", this.handleClick);
  }

  componentWillUnmount() {
    $(this.mRef).find(".action").off("click", this.handleClick);
  }

  handleClick() {
    if (this.state.isEdit)
      $(this.mRef)
        .find(".static-field")
        .text($(this.mRef).find(".input-field").val());

    this.setState({
      isEdit: !this.state.isEdit,
    });
  }

  getActionIcon() {
    return (
      '<i class="fa fa-times show-on-edit" />' +
      '<i class="fa fa-pencil hide-on-edit" />'
    );
  }

  render() {
    const { isEdit } = this.state;
    const { children, type } = this.props;

    return (
      <div
        className={`editable-field ${
          isEdit ? "edit-mode" : "read-mode"
        } first-type`}
        ref={(ref) => (this.mRef = ref)}
      >
        {children}
      </div>
    );
  }
}

EditableField.propTypes = {
  children: PropTypes.element.isRequired,
};

export default EditableField;



// WEBPACK FOOTER //
// ./client/react/Admin/components/EditableField/index.jsx